"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const node_fetch_1 = require("node-fetch");
const bignumber_js_1 = require("bignumber.js");
class BlockScaleFetchingService {
    constructor() {
        this.apiAddress = 'https://dev.blockscale.net/api/gasexpress.json';
    }
    fetchGasPrice() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield node_fetch_1.default(this.apiAddress);
            if (!response.ok) {
                throw new Error(response.statusText);
            }
            const json = yield response.json();
            const toWei = (val) => {
                const gwei = 1000000000;
                return val * gwei;
            };
            return {
                average: new bignumber_js_1.default(toWei(json.standard)),
                fast: new bignumber_js_1.default(toWei(json.fast)),
                fastest: new bignumber_js_1.default(toWei(json.fastest)),
                safeLow: new bignumber_js_1.default(toWei(json.safeLow))
            };
        });
    }
}
exports.BlockScaleFetchingService = BlockScaleFetchingService;
//# sourceMappingURL=BlockScaleFetchingService.js.map